import { DOCUMENT_TYPES } from '@savgroup-front-common/constants';
import { ADDITIONAL_INFORMATION_TYPES } from '@savgroup-front-common/types';

import { NeededInformation } from '../AdditionalInformation.context';
import { buildInputName } from '../AdditionalInformationInput.helpers';

export const verifyThatFileNeedToBeUploadedToAttachment = ({
  neededInformationItems,
  name,
  prefixFormName,
  claimIds,
}: {
  neededInformationItems: NeededInformation[];
  name: string;
  prefixFormName?: string;
  claimIds?: string[];
}) => {
  return neededInformationItems
    .filter((neededInformationItem) => {
      const targetName = buildInputName({
        prefixFormName,
        name: neededInformationItem.internalId,
      });

      return targetName !== name;
    })
    .every((neededInformationItem) => {
      return claimIds?.every((claimId) => {
        return !(
          claimId &&
          neededInformationItem.documentType === DOCUMENT_TYPES.NAME_PLATE &&
          neededInformationItem.type === ADDITIONAL_INFORMATION_TYPES.FILE &&
          neededInformationItem.claimIds?.includes(claimId) &&
          neededInformationItem.claimIds.length > 0
        );
      });
    });
};
